import { c as _c } from "react/compiler-runtime";
import { IntegrationsDisconnectDialog } from "@components/integrations-dialog/integrations-disconnect-dialog";
import { IntegrationsInProgressDialog } from "@components/integrations-dialog/integrations-in-progress-dialog";
import { IntegrationsSuccessfulDialog } from "@components/integrations-dialog/integrations-successful-dialog";
/** All the dialogs for integrations process */
export function IntegrationDialog(t0) {
  const $ = _c(10);
  const {
    integrationId,
    dialogState,
    onSuccessDialogConfirm,
    onInProgressDialogCancel,
    onDisconnectDialogConfirm,
    onDisconnectDialogCancel
  } = t0;
  switch (dialogState) {
    case "inProgress":
      {
        let t1;
        if ($[0] !== integrationId || $[1] !== onInProgressDialogCancel) {
          t1 = <IntegrationsInProgressDialog integrationId={integrationId} dialogCancelCallback={onInProgressDialogCancel} />;
          $[0] = integrationId;
          $[1] = onInProgressDialogCancel;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "disconnect":
      {
        let t1;
        if ($[3] !== integrationId || $[4] !== onDisconnectDialogCancel || $[5] !== onDisconnectDialogConfirm) {
          t1 = <IntegrationsDisconnectDialog dialogConfirmCallback={onDisconnectDialogConfirm} dialogCancelCallback={onDisconnectDialogCancel} integrationId={integrationId} />;
          $[3] = integrationId;
          $[4] = onDisconnectDialogCancel;
          $[5] = onDisconnectDialogConfirm;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "success":
      {
        let t1;
        if ($[7] !== integrationId || $[8] !== onSuccessDialogConfirm) {
          t1 = <IntegrationsSuccessfulDialog integrationId={integrationId} dialogConfirmCallback={onSuccessDialogConfirm} />;
          $[7] = integrationId;
          $[8] = onSuccessDialogConfirm;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "none":
      {
        return null;
      }
  }
}